import { z } from "zod";

/**
 * Formato unico de erro da API (RFC 9457 - Problem Details).
 *
 * Existe aqui, em @base/contracts, porque o front precisa da MESMA definicao
 * para exibir o erro. Duas definicoes divergentes de erro foi o que motivou
 * centralizar: a API mudava o campo e a tela seguia lendo o antigo.
 */
export const problemDetailsSchema = z.object({
  /** URI estavel do tipo de problema. Serve de chave para o front decidir a mensagem. */
  type: z.string().min(1),
  title: z.string().min(1),
  status: z.number().int().min(400).max(599),
  detail: z.string(),
  /** Correlaciona a resposta com o log do servidor. Sempre presente. */
  requestId: z.string().min(1),
  /** Erros por campo, preenchido apenas em falha de validacao. */
  errors: z.record(z.string(), z.array(z.string())).optional(),
});

export type ProblemDetails = z.infer<typeof problemDetailsSchema>;

export const BASE_URI_PROBLEMA = "https://docs.example.com/problemas";

export function uriDoProblema(codigo: string): string {
  return `${BASE_URI_PROBLEMA}/${codigo}`;
}

export function ehProblemDetails(valor: unknown): valor is ProblemDetails {
  return problemDetailsSchema.safeParse(valor).success;
}
